<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">{{ isEdit ? 'Editar desconto' : 'Adicionar desconto' }}</h5>
        <div role="button" class="btn-close" @click="close"></div>
      </div>

      <div class="modal-body">
        <error-component :errors="errors" v-if="showError" />

        <form>
          <row-component>
            <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
              <label>Valor total:</label>
              <input-component :model-value="itemData.totalPartPrice" disabled />
            </col-component>

            <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
              <label>Desconto %:</label>
              <input-component v-model="formData.percentage" @input="onPercentageChange" />
            </col-component>

            <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
              <label>Valor desconto:</label>
              <input-component v-model="formData.price" v-money="MONEY" @input="onPriceChange" />
            </col-component>
          </row-component>

          <div class="text-end mt-3">
            <button-submit
              :disabled="sendForm"
              :icon="isEdit ? 'save' : 'plus'"
              :name="isEdit ? 'Salvar' : 'Adicionar'"
              @click="submit"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import RowComponent from '@/components/row/RowComponent.vue';
import ColComponent from '@/components/row/ColComponent.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import ButtonSubmit from '@/components/buttons/ButtonSubmit.vue';
import ErrorComponent from '@/components/alerts/ErrorComponent.vue';
import { VMoney } from 'v-money';
import { MONEY } from '@/configs/constants';
import { useToast } from 'vue-toastification';

const toast = useToast();

export default {
  name: 'OrderPartDiscount',

  components: {
    RowComponent,
    ColComponent,
    InputComponent,
    ButtonSubmit,
    ErrorComponent
  },

  directives: {
    money: VMoney
  },

  props: {
    itemData: {
      type: Object,
      required: true
    }
  },

  created() {
    this.formData.percentage = this.itemData.discount?.percentage || 0;
    this.formData.price = this.itemData.discount?.price || '0,00';
  },

  data() {
    return {
      MONEY,
      formData: {
        percentage: 0,
        price: '0,00'
      },
      errors: [],
      showError: false,
      sendForm: false
    };
  },

  computed: {
    isEdit() {
      return !!this.itemData.discount?.id;
    }
  },

  methods: {
    close() {
      this.$emit('close');
    },

    parseMoney(value) {
      if (!value) return 0;
      return Number(String(value).replace(/\./g, '').replace(',', '.').replace(/[^\d.-]/g, '')) || 0;
    },

    formatMoney(value) {
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value || 0);
    },

    onPercentageChange() {
      let percentage = Number(String(this.formData.percentage).replace(',', '.')) || 0;
      if (percentage < 0) percentage = 0;
      if (percentage > 100) percentage = 100;
      this.formData.percentage = percentage;

      const total = this.parseMoney(this.itemData.totalPartPrice);
      this.formData.price = this.formatMoney((total * percentage) / 100);
    },

    onPriceChange() {
      const discountValue = this.parseMoney(this.formData.price);
      const total = this.parseMoney(this.itemData.totalPartPrice);
      this.formData.percentage = total > 0 ? parseFloat(((discountValue / total) * 100).toFixed(2)) : 0;
    },

    submit() {
      const percentage = Number(this.formData.percentage) || 0;
      if (percentage < 0 || percentage > 100) {
        toast.error('Porcentagem deve estar entre 0 e 100', { timeout: 1500 });
        return;
      }

      if (this.sendForm) return;
      this.sendForm = true;

      const payload = {
        order_part_id: this.itemData.id,
        percentage,
        price: this.formData.price || '0,00'
      };

      const action = this.isEdit ? 'updateOrderPartDiscount' : 'storeOrderPartDiscount';
      if (this.isEdit) payload.id = this.itemData.discount.id;

      this.$store
        .dispatch(action, payload)
        .then(() => {
          this.sendForm = false;
          toast.success('Cadastro efetuado com sucesso', { timeout: 1500 });
          this.$emit('saved');
          this.close();
        })
        .catch(e => {
          this.sendForm = false;
          this.showError = true;
          this.errors = e.response?.data?.errors || [];
          toast.error('Erro ao salvar desconto', { timeout: 1500 });
        });
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  width: 900px;
  max-width: 90%;
  position: relative;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
</style>
